module.exports = __webpack_public_path__ + "static/media/advertisers.310c8abd.png";